import {Component, OnDestroy, OnInit} from '@angular/core';
import {ITrainingRecordSummary} from '../../../message-models/training-record-summary.interface';
import {TrainingRecordsService} from '../../../training-records/services/training-records.service';
import {EcaBreadcrumbService} from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import {IBreadcrumb} from '../../../eca-breadcrumb/models/breadcrumb.interface';
import {OurUserService} from "../../../users/services/user.service";
import {IUserInfo} from "../../../users/models/userInfo.interface";
import {consts} from "../../../common/modals/consts";
import {Subscription} from "rxjs";
import {EcaConfirmInfoModalOptions} from '../../../shared/models/confirm-info-modal-options.class';
import {EcaConfirmProcessService} from '../../../shared/services/eca-confirm-process.service';
import {ErrorHandlingService} from '../../../services/error-handling.service';
import {AlertsService} from '../../../alerts/services/alerts.service';
import {HelpConsts} from '../../../help/models/help-consts';
import {HelpModalService} from '../../../help/services/help-modal.service';

@Component({
  selector: 'app-company-operative-training-records-page',
  templateUrl: './company-operative-training-records-page.component.html',
  styleUrls: ['./company-operative-training-records-page.component.scss']
})
export class CompanyOperativeTrainingRecordsPageComponent implements OnInit, OnDestroy {
  trainingRecords: ITrainingRecordSummary[] = [];
  trainingRecordsLoading: boolean = true;

  loggedInUser: IUserInfo;
  private companyId: string = consts.emptyGuid;
  private subscription: Subscription;

  constructor(private trainingRecordsService: TrainingRecordsService,
              private ecaBreadcrumbService: EcaBreadcrumbService,
              private userService: OurUserService,
              private errorHandlingService: ErrorHandlingService,
              private alertsService: AlertsService,
              private helpService: HelpModalService,
              private confirmProcessService: EcaConfirmProcessService,
  ) { }

  ngOnInit(): void {



    this.userService.getLoggedInUser().subscribe(user => {
      // this.updateUserAndReload(user);
      this.subscription = this.userService.getLoggedInUserSubject()
        .subscribe(user =>
        {
        this.updateUserAndReload(user);
        }
        )
      this.populateBreadcrumbs();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })


  }

  private updateUserAndReload(user: IUserInfo){
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    if(this.companyId !== undefined || this.companyId !== consts.emptyGuid){
      this.loadTrainingRecordSummaries();
    }

  }

  loadTrainingRecordSummaries() {
    this.trainingRecordsService.getTrainingRecordSummariesForCompany(this.companyId).subscribe(trainingRecords => {
      this.trainingRecords = [];
      trainingRecords?.forEach(trainingRecord => this.trainingRecords.push(trainingRecord));
      this.trainingRecordsLoading = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
    operativeBreadCrumbs.push({label: 'Operatives', iconName: 'users', routeLink: '/operatives'} as IBreadcrumb);
    operativeBreadCrumbs.push({label: 'Training Records', iconName: 'graduation-cap'} as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openTrainingRecordsHelp() {
    this.helpService.openHelpModal(HelpConsts.OperativeTrainingRecordsHelp);
  }
}
